import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import Chart, { ChartData, ChartOptions } from 'chart.js/auto';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent {
  @Input() view: string = 'monthly'; // monthly, quarterly, yearly
  @Input() selectedYear: number = new Date().getFullYear(); // Default to current year

  pieChart: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['view'] || changes['selectedYear']) {
      this.loadChart();
    }
  }

  //Load initial chart data
  ngAfterViewInit(): void {
    this.loadChart();
  }

  loadChart() {
    const ctx = document.getElementById('pieChartCanvas') as HTMLCanvasElement;
    if (this.pieChart) {
      this.pieChart.destroy(); // Destroy existing chart before reloading
    }

    const data = this.getChartData(this.view, this.selectedYear);

    this.pieChart = new Chart(ctx, {
      type: 'pie',
      data: data,
      options: this.getChartOptions(),
    });
  }

  getChartData(viewType: string, year: number): ChartData {
    let services = 0;
    let partSellIncome = 0;
    let data:any;

    // Example Data
    if (viewType === 'Monthly') {
      data = this.getMonthlyByYear(year);
    } else if (viewType === 'Quaterly') {
      data = this.getQuaterlyByYear(year);
    } else if (viewType === 'Yearly') {
      data = this.getYearlyData(year);
    }

    return {
      labels: ['Service Charges', 'Part Sales'],
      datasets: [
        {
          data: [data.services, data.partSell],
          backgroundColor: ['#4CAF50', '#FFC107'],
          hoverOffset: 4,
        }
      ],
    };
  }

  getChartOptions(): ChartOptions {
    return {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem: any) => {
              const value = tooltipItem.raw;
              const total = tooltipItem.dataset.data.reduce((a: number, b: number) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(2);
              return `${tooltipItem.label}: ${percentage}%`;
            },
          },
        },
      },
    };
  }

  getQuaterlyByYear(year: any) {
    if (year == 2025) {
      return {
        "year": 2025,
        labels: ['Service Charges', 'Part Sales'],
        services: 19000,
        partSell: 10000
      };
    } else if (year == 2024) {
      return {
        "year": 2024,
        labels: ['Service Charges', 'Part Sales'],
        services: 27000,
        partSell: 9700
      };
    } else {
      return {
        "year": 2023,
        labels: ['Service Charges', 'Part Sales'],
        services: 13000,
        partSell: 8700
      };
    }
  }

  getMonthlyByYear(year: any) {
    if (year == 2025) {
      return {
        "year": 2025,
        labels: ['Service Charges', 'Part Sales'],
        services: 6200,
        partSell: 3600
      };
    } else if (year == 2024) {
      return {
        "year": 2024,
        labels: ['Service Charges', 'Part Sales'],
        services: 5800,
        partSell: 6900
      };
    } else {
      return {
        "year": 2023,
        labels: ['Service Charges', 'Part Sales'],
        services: 4500,
        partSell: 2300
      };
    }
  }

  getYearlyData(year: any) {
    if (year == 2025) {
      return {
        "year": 2025,
        labels: ['Service Charges', 'Part Sales'],
        services: 34000,
        partSell: 38000
      };
    } else if (year == 2024) {
      return {
        "year": 2024,
        labels: ['Service Charges', 'Part Sales'],
        services: 97000,
        partSell: 68000
      };
    } else {
      return {
        "year": 2023,
        labels: ['Service Charges', 'Part Sales'],
        services: 45000,
        partSell: 33000
      };
    }
  }
}
